import { clone, cloneDeep } from 'lodash';

import fields from './fields';
import groups from './groups';

// 将配置文件转换成真实数据
export function getFieldsByGroup(config) {
  if (!config) return;
  return config.map((conf) => {
    const groupKey = conf.key;
    const groupChildren = conf.children;

    // 归在分组下的列信息
    if (groupChildren) {
      const group = groups[groupKey];
      if (group) {
        const _group = clone(group);
        _group.children = groupChildren.map((child) => {
          const fieldKey = child.key;
          // 将配置文件中的自定义属性合并进原始数据
          const _field = Object.assign(getField(fieldKey) || {}, child);
          return _field;
        });
        return _group;
      }
      // 单个列信息
    } else {
      return Object.assign(conf, getField(groupKey));
    }
  });
}

// 获取单个列信息
export function getField(key) {
  if (!key) return null;
  return cloneDeep(fields[key]);
}

// 获取多个列信息
export function getFieldsByList(list) {
  return list.map((item) => {
    return getField(item);
  });
}

// 获取用于展示的列信息
export function getFieldsByBranches(columns) {
  if (!columns) return;
  const _columns = cloneDeep(columns);
  return _columns.map((column) => {
    if (column) {
      if(column.children) {
        column.children = column.children.reduce((prev, current) => {
          if (current.branches) {
            return prev.concat(current.branches);
          } else {
            prev.push(current);
            return prev;
          }
        }, []);
      }  
      return column;
    }
  });
}
